module.exports = __webpack_public_path__ + "assets/img/store-text-1.e8c96113.png";